import { render, staticRenderFns } from "./FundingSettingsSection.vue?vue&type=template&id=64948570&scoped=true"
import script from "./FundingSettingsSection.vue?vue&type=script&lang=js"
export * from "./FundingSettingsSection.vue?vue&type=script&lang=js"
import style0 from "./FundingSettingsSection.vue?vue&type=style&index=0&id=64948570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64948570",
  null
  
)

export default component.exports